import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UTurnLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"u_turn_left"}/>
}
